import React, { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { ToastContainer, toast } from 'react-toastify';
import { Icon } from '@iconify/react';
import Select from 'react-select';
import { getCompressed, submitCompressed } from '../../Services/allApi';

function CompressD({ videoId }) {
    const baseUrl=process.env.REACT_APP_BASEURL
    const [rows, setRows] = useState([
        // { name: 'name', format: '144p', start: '0.001', end: '3.12' },
        // { name: 'name', format: '240p', start: '0.02', end: '5.12' },
        // { name: 'name', format: '360p', start: '1.23', end: '10.54' },
    ]);
    const [StopApi, setStopApi] = useState(false)
    const [dataFromForm, setDataFromForm] = useState({
        resolution: '',
        start: '',
        end: '',
    });

    const [formatOptions, setFormatOptions] = useState([]);
    
    // submit / start new compression
    const handleSubmit = () => {
        const { resolution, start, end } = dataFromForm;
        if (resolution) {
            const newRow = {
                name: 'name',
                format: resolution.label,
                start: start,
                end: end,
            };

            // setRows([...rows, newRow]);
            // setDataFromForm({ resolution: '', start: '', end: '' });
            toast.success('Format added successfully!');
            PostCompression()
        } else {
            toast.error('Please fill out all fields.');
        }
    };

    const handleChange = (name, value) => {
        setDataFromForm({ ...dataFromForm, [name]: value });
    };

    // get compressions
    const getCompressedListApi = async () => {
       try{
        const result = await getCompressed(videoId);
        if (result) {
            const formatKeys = Object?.keys(result?.data).filter(key => key !== 'data');
            const options = formatKeys?.map(key => ({
                label: key,
            }));
            setFormatOptions(options);
            setRows(result?.data?.data)
            console.log(result?.data);
        }
        
       }catch(err){
        // toast.warning("There was an error while compressing the video")
       }
    };

    useEffect(() => {
        if (StopApi) {
            return;
        }

        const interval = setInterval(() => {
            getCompressedListApi();
        }, 5000);

        // Clean up interval on component unmount or if StopApi changes to true
        return () => clearInterval(interval);
    }, [StopApi]);


    const PostCompression = async () => {
        // const token = sessionStorage.getItem('access_token');
        // const reqHeader = {
        //     "Content-Type": "application/json",
        //     "Authorization": token,
        // };
        const dataEnteredToCompress = {
            video_id: videoId,
            resolution: dataFromForm.resolution,
            // start_time:dataFromForm.start ,
            // end_time: dataFromForm.end
            start_time: dataFromForm?.start,
            end_time: dataFromForm?.end
        }
        const res = await submitCompressed(dataEnteredToCompress)
        if (res?.data?.data?.processed_file_path) {
            setStopApi(true)
        }

    }

    useEffect(()=>{
        getCompressedListApi()
    },[])
    return (
        <div className='flex flex-col justify-center items-center bg-success p-1 rounded-lg' style={{ border: '1px dashed #001F33' }}>
            <ToastContainer />
            <h3 className='text-blue-700 text-xl font-bold text-center'>Available formats</h3>

            <TableContainer component={Paper} className='w-full text-xs'>
                <Table sx={{ minWidth: 300 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell style={{ fontWeight: 'bold', fontFamily: 'ropa sans' }}>Name</TableCell>
                            <TableCell style={{ fontWeight: 'bold', fontFamily: 'ropa sans' }} align="center">Resolution</TableCell>
                            <TableCell style={{ fontWeight: 'bold', fontFamily: 'ropa sans' }} align="center">Download</TableCell>
                            <TableCell style={{ fontWeight: 'bold', fontFamily: 'ropa sans' }} align="center">Start</TableCell>
                            <TableCell style={{ fontWeight: 'bold', fontFamily: 'ropa sans' }} align="center">End</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.length > 0 ? rows?.map((row, index) => (
                            <TableRow
                                style={{ backgroundColor: `${index % 2 === 0 ? '#F3F4F6' : '#F9FAFB'}` }}
                                key={index}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell style={{ fontFamily: 'ropa sans' }} component="th" scope="row">
                                    {row?.file_name}
                                </TableCell>
                                <TableCell style={{ fontFamily: 'ropa sans', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }} align="center">{row?.resolution}</TableCell>
                                <TableCell style={{ fontFamily: 'ropa sans' }} align="center">
                                    <div className='flex justify-center items-center w-full'>
                                        {row?.processed_file_path ? (
                                            <a href={`${baseUrl}${row.processed_file_path}`} target='_blank' download>
                                                <Icon icon="line-md:download-outline-loop" className='text-blue-500 text-lg' />
                                            </a>
                                        ) : (
                                            <span className='text-gray-400 text-xs'>
                                                {row?.status === 'failed' ? 'Failed' : row?.file_name === 'Resizing File..' ? 'Processing...' : 'Queued...'}
                                            </span>
                                        )}
                                    </div>

                                </TableCell>
                                <TableCell style={{ fontFamily: 'ropa sans' }} align="center">{row?.start_time}</TableCell>
                                <TableCell style={{ fontFamily: 'ropa sans' }} align="center">{row?.end_time}</TableCell>
                            </TableRow>

                        ))
                            : <TableRow
                                style={{ backgroundColor: '#F3F4F6' }}
                                // key={index}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell style={{ fontFamily: 'ropa sans' }} align="center">No data found</TableCell>
                            </TableRow>
                        }
                    </TableBody>
                </Table>
            </TableContainer>

            <div className='flex justify-end w-full'>
                <button className='flex flex-row justify-center items-center px-4 py-2 bg-gray-100 shadow hover:text-white mt-2 rounded-full border hover:bg-primary'>
                    <span>Refresh</span><Icon icon="uil:refresh" />
                </button>
            </div>

            <h3 className='text-blue-700 text-xl font-bold text-center mb-2'>Compress New Format</h3>

            <div className='flex md:flex-row flex-col justify-evenly items-center gap-3'>
                <div className='w-full flex flex-col'>
                    <label htmlFor="format">Resolution</label>
                    <Select
                        id='format'
                        options={formatOptions}
                        value={dataFromForm.resolution.label}
                        onChange={(option) => handleChange('resolution', option.label)}
                        styles={{
                            control: (baseStyles, state) => ({
                                ...baseStyles,
                                borderColor: '#3B82F6',
                                height: '2.5rem',
                                borderRadius: '0.5rem',
                                minWidth: '10rem'
                            }),
                        }}
                    />
                </div>

                <div className='w-full flex flex-col'>
                    <label htmlFor="start">Start time</label>
                    <input
                        // readOnly
                        type="text"
                        id="start"
                        className='w-40 rounded-lg shadow-lg border border-blue-500 h-10'
                        placeholder='example: 00.05'
                        value={dataFromForm.start}
                        onChange={(e) => handleChange('start', e.target.value)}
                    />
                </div>

                <div className='w-full flex flex-col'>
                    <label htmlFor="end">End time</label>
                    <input
                        // readOnly
                        type="text"
                        id="end"
                        className='w-40 rounded-lg shadow-lg border border-blue-500 h-10'
                        placeholder='example: 05.25'
                        value={dataFromForm.end}
                        onChange={(e) => handleChange('end', e.target.value)}
                    />
                </div>

                <div className='w-full flex flex-col'>
                    <label style={{ visibility: 'hidden' }} htmlFor="submit">Format</label>
                    <button
                        className='px-4 hover:bg-primary hover:text-white rounded-lg shadow-lg border border-blue-500 h-10 md:mb-0 mb-5'
                        onClick={handleSubmit}
                    >
                        Submit
                    </button>
                </div>
            </div>
        </div>
    );
}

export default CompressD;
